export const formatProjectName = (name: string) => {
  const displayText = name.length >= 9 ? name.slice(0, 8) + '…' : name;
  return displayText;
};
